import { Suspense, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { refreshToken } from "store/login/loginSlice";
import { checkQAContentRole } from "helpers/roleChecker";

const RouteRequiresLogin = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const access_token = localStorage.getItem("access_token");

  const isLoggedIn = checkQAContentRole(access_token);
  const { userID } = useSelector(state => state.login);
  useEffect(() => {
    if (userID === null) {
      dispatch(refreshToken());
    }
  }, [dispatch, userID]);

  return (
    <Route
      {...rest}
      render={props => {
        return isLoggedIn ? (
          <Suspense fallback={<div />}>
            <Component {...props} />
          </Suspense>
        ) : (
          <Redirect to="/login" />
        );
      }}
    />
  );
};

export default RouteRequiresLogin;
